"use client";

import { c as _c } from "react/compiler-runtime";
import { Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, NumberDisplay, TextBody, TextBodySkeleton } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { useTrackSwapEvent } from "../../hooks/use-track-swap-event";
import { readSwapImpactFromQuote } from "../../provider/readSwapImpact";
import { useSwapContext } from "../../provider/SwapContext";
import { CONFIRM_BUTTON_ENABLE_DELAY_MS, MAX_SLIPPAGE_WARNING_THRESHOLD, SWAP_IMPACT_WARNING_THRESHOLD } from "../constants";
export function SwapConfirmationModal(t0) {
  const $ = _c(93);
  const {
    open
  } = t0;
  const t = useTranslations("wallet.SwapConfirmationModal");
  const {
    handleSubmit,
    control
  } = useFormContext();
  const {
    quote,
    setShouldShowConfirmationModal,
    isLoadingQuote,
    onSubmit
  } = useSwapContext();
  const trackSwapEvent = useTrackSwapEvent(quote);
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "maxSlippage"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const maxSlippage = useWatch(t1);
  const [hasTrackedShown, setHasTrackedShown] = useState(false);
  let t2;
  let t3;
  if ($[2] !== open) {
    t2 = () => {
      if (open) {
        setTimeout(() => {
          setIsConfirmEnabled(true);
        }, CONFIRM_BUTTON_ENABLE_DELAY_MS);
      } else {
        setIsConfirmEnabled(false);
      }
    };
    t3 = [open, setIsConfirmEnabled];
    $[2] = open;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== setShouldShowConfirmationModal) {
    t4 = isOpen => {
      if (!isOpen) {
        setShouldShowConfirmationModal(false);
      }
    };
    $[5] = setShouldShowConfirmationModal;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleOnOpenChange = t4;
  let t5;
  if ($[7] !== quote) {
    t5 = quote ? readSwapImpactFromQuote(quote) : null;
    $[7] = quote;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const swapImpact = t5;
  let t6;
  if ($[9] !== hasTrackedShown || $[10] !== maxSlippage || $[11] !== open || $[12] !== swapImpact || $[13] !== trackSwapEvent) {
    t6 = () => {
      if (!open) {
        if (hasTrackedShown) {
          setHasTrackedShown(false);
        }
        return;
      }
      const hasHighImpact = swapImpact && bn(swapImpact.percent).lt(SWAP_IMPACT_WARNING_THRESHOLD);
      const hasHighSlippage = maxSlippage && maxSlippage > MAX_SLIPPAGE_WARNING_THRESHOLD;
      if (open && !hasTrackedShown) {
        const warningType = hasHighImpact && hasHighSlippage ? "both" : hasHighImpact ? "high_impact" : "high_slippage";
        trackSwapEvent("Swap Confirmation Modal Shown", {
          warningType,
          impactPercent: swapImpact ? Number(swapImpact.percent) : null,
          impactUsd: swapImpact ? Number(swapImpact.usd) : null,
          maxSlippage: maxSlippage ?? null
        });
        setHasTrackedShown(true);
      }
    };
    $[9] = hasTrackedShown;
    $[10] = maxSlippage;
    $[11] = open;
    $[12] = swapImpact;
    $[13] = trackSwapEvent;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = swapImpact?.percent;
  const t8 = swapImpact?.usd;
  let t9;
  if ($[15] !== hasTrackedShown || $[16] !== maxSlippage || $[17] !== open || $[18] !== t7 || $[19] !== t8 || $[20] !== trackSwapEvent) {
    t9 = [open, t7, t8, maxSlippage, trackSwapEvent, hasTrackedShown];
    $[15] = hasTrackedShown;
    $[16] = maxSlippage;
    $[17] = open;
    $[18] = t7;
    $[19] = t8;
    $[20] = trackSwapEvent;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  useEffect(t6, t9);
  let t10;
  if ($[22] !== maxSlippage || $[23] !== setShouldShowConfirmationModal || $[24] !== swapImpact) {
    t10 = () => {
      if (swapImpact && bn(swapImpact.percent).gte(SWAP_IMPACT_WARNING_THRESHOLD) && maxSlippage < MAX_SLIPPAGE_WARNING_THRESHOLD) {
        setShouldShowConfirmationModal(false);
      }
    };
    $[22] = maxSlippage;
    $[23] = setShouldShowConfirmationModal;
    $[24] = swapImpact;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = swapImpact?.percent;
  let t12;
  if ($[26] !== maxSlippage || $[27] !== setShouldShowConfirmationModal || $[28] !== t11) {
    t12 = [t11, maxSlippage, setShouldShowConfirmationModal];
    $[26] = maxSlippage;
    $[27] = setShouldShowConfirmationModal;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  useEffect(t10, t12);
  let t13;
  if ($[30] !== swapImpact) {
    t13 = swapImpact && bn(swapImpact.percent).lt(SWAP_IMPACT_WARNING_THRESHOLD);
    $[30] = swapImpact;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const hasHighImpact_0 = t13;
  const hasHighSlippage_0 = maxSlippage && maxSlippage > MAX_SLIPPAGE_WARNING_THRESHOLD;
  let t14;
  if ($[32] !== swapImpact) {
    t14 = swapImpact ? <><TextBody color="error-1"><NumberDisplay display="percent" value={Math.abs(Number(swapImpact.percent)) / 100} /></TextBody>{" "}<TextBody>(<NumberDisplay display="usd" value={swapImpact.usd} />)</TextBody></> : null;
    $[32] = swapImpact;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const impactContent = t14;
  let t15;
  if ($[34] !== maxSlippage) {
    t15 = maxSlippage ? <TextBody color="error-1"><NumberDisplay display="percent" value={maxSlippage / 100} /></TextBody> : null;
    $[34] = maxSlippage;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const slippageContent = t15;
  let t16;
  if ($[36] !== handleSubmit || $[37] !== maxSlippage || $[38] !== onSubmit || $[39] !== setShouldShowConfirmationModal || $[40] !== swapImpact || $[41] !== trackSwapEvent) {
    t16 = () => {
      const hasHighImpact_1 = swapImpact && bn(swapImpact.percent).lt(SWAP_IMPACT_WARNING_THRESHOLD);
      const hasHighSlippage_1 = maxSlippage && maxSlippage > MAX_SLIPPAGE_WARNING_THRESHOLD;
      const warningType_0 = hasHighImpact_1 && hasHighSlippage_1 ? "both" : hasHighImpact_1 ? "high_impact" : "high_slippage";
      trackSwapEvent("Swap Confirmation Modal Confirmed", {
        warningType: warningType_0,
        impactPercent: swapImpact ? Number(swapImpact.percent) : null,
        impactUsd: swapImpact ? Number(swapImpact.usd) : null,
        maxSlippage: maxSlippage ?? null
      });
      setShouldShowConfirmationModal(false);
      handleSubmit(onSubmit)();
    };
    $[36] = handleSubmit;
    $[37] = maxSlippage;
    $[38] = onSubmit;
    $[39] = setShouldShowConfirmationModal;
    $[40] = swapImpact;
    $[41] = trackSwapEvent;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  const handleContinue = t16;
  let t17;
  if ($[43] !== hasHighImpact_0 || $[44] !== hasHighSlippage_0 || $[45] !== t) {
    t17 = () => {
      if (hasHighImpact_0 && hasHighSlippage_0) {
        return t("multipleWarnings");
      }
      if (hasHighSlippage_0) {
        return t("highSlippageWarning");
      }
      return t("highSwapImpact");
    };
    $[43] = hasHighImpact_0;
    $[44] = hasHighSlippage_0;
    $[45] = t;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  const getModalTitle = t17;
  let t18;
  if ($[47] !== hasHighImpact_0 || $[48] !== hasHighSlippage_0 || $[49] !== impactContent || $[50] !== slippageContent || $[51] !== swapImpact || $[52] !== t) {
    t18 = () => {
      if (hasHighImpact_0 && hasHighSlippage_0) {
        return <>{t.rich("impactDescription", {
            impact: () => impactContent
          })}<br /><br />{t.rich("slippageDescription", {
            slippage: () => slippageContent
          })}</>;
      }
      if (hasHighSlippage_0) {
        return t.rich("slippageDescription", {
          slippage: () => slippageContent
        });
      }
      if (swapImpact) {
        return t.rich("impactDescription", {
          impact: () => impactContent
        });
      }
      return <><TextBodySkeleton className="w-full" /><TextBodySkeleton className="w-6" /></>;
    };
    $[47] = hasHighImpact_0;
    $[48] = hasHighSlippage_0;
    $[49] = impactContent;
    $[50] = slippageContent;
    $[51] = swapImpact;
    $[52] = t;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  const getModalDescription = t18;
  let t19;
  if ($[54] !== getModalTitle) {
    t19 = getModalTitle();
    $[54] = getModalTitle;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  let t20;
  if ($[56] !== t19) {
    t20 = <ModalHeader><ModalHeaderTitle>{t19}</ModalHeaderTitle></ModalHeader>;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== getModalDescription) {
    t21 = getModalDescription();
    $[58] = getModalDescription;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== t21) {
    t22 = <TextBody color="text-secondary">{t21}</TextBody>;
    $[60] = t21;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t) {
    t23 = t("continue");
    $[62] = t;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== t23) {
    t24 = <TextBody color="text-secondary">{t23}</TextBody>;
    $[64] = t23;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== t22 || $[67] !== t24) {
    t25 = <ModalBody className="gap-4">{t22}{t24}</ModalBody>;
    $[66] = t22;
    $[67] = t24;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== setShouldShowConfirmationModal) {
    t26 = () => setShouldShowConfirmationModal(false);
    $[69] = setShouldShowConfirmationModal;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t) {
    t27 = t("cancel");
    $[71] = t;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t26 || $[74] !== t27) {
    t28 = <ModalFooterButton onClick={t26} variant="secondary">{t27}</ModalFooterButton>;
    $[73] = t26;
    $[74] = t27;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  const t29 = !isConfirmEnabled || isLoadingQuote;
  let t30;
  if ($[76] !== t) {
    t30 = t("confirm");
    $[76] = t;
    $[77] = t30;
  } else {
    t30 = $[77];
  }
  let t31;
  if ($[78] !== handleContinue || $[79] !== t29 || $[80] !== t30) {
    t31 = <ModalFooterButton disabled={t29} onClick={handleContinue} variant="destructive">{t30}</ModalFooterButton>;
    $[78] = handleContinue;
    $[79] = t29;
    $[80] = t30;
    $[81] = t31;
  } else {
    t31 = $[81];
  }
  let t32;
  if ($[82] !== t28 || $[83] !== t31) {
    t32 = <ModalFooter>{t28}{t31}</ModalFooter>;
    $[82] = t28;
    $[83] = t31;
    $[84] = t32;
  } else {
    t32 = $[84];
  }
  let t33;
  if ($[85] !== t20 || $[86] !== t25 || $[87] !== t32) {
    t33 = <>{t20}{t25}{t32}</>;
    $[85] = t20;
    $[86] = t25;
    $[87] = t32;
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  let t34;
  if ($[89] !== handleOnOpenChange || $[90] !== open || $[91] !== t33) {
    t34 = <Modal content={t33} onOpenChange={handleOnOpenChange} open={open} />;
    $[89] = handleOnOpenChange;
    $[90] = open;
    $[91] = t33;
    $[92] = t34;
  } else {
    t34 = $[92];
  }
  return t34;
}